import {
  Flex,
  FormControl,
  FormLabel,
  HStack,
  Input,
  Stack,
  Text,
} from '@chakra-ui/react';
import { useCallback, useState } from 'react';

import { SubSectionHeading } from '../../shared/Typography';
import { ContentBox } from '../../components/ContentBox';
import { StackWithDivider } from '../components/StackWithDivider';
import { COLORS } from '../../constant';
import { DropdownApplicationsMenu } from '../../shared/DropdownApplicationsMenu';
import { Application } from '@finch-api/developer-dashboard-common';

export function PensionProSettingsPage() {
  const [application, setApplication] = useState<Application | undefined>();
  const [tenantId, setTenantId] = useState<string | undefined>();
  const onChange = useCallback(
    (app: Application) => {
      // fetch pp capabilities
      // - if no -> show error msg
      // - if yes -> load tenant id

      // set tenant id
      setApplication(app);
    },
    [setApplication],
  );

  return (
    <ContentBox>
      <StackWithDivider>
        <SubSectionHeading px="6" py="4">
          <HStack justifyContent="space-between">
            <Text>PensionPro</Text>
            <DropdownApplicationsMenu
              onChange={onChange}
              applicationId={application?.id}
            />
          </HStack>
        </SubSectionHeading>
        <HStack
          padding="6"
          paddingTop="4"
          gap="80px"
          justifyContent="space-evenly"
        >
          <Stack gap="2">
            <Text fontWeight="500" color={COLORS.FINCH.BLACK}>
              Add Your Tenant ID
            </Text>
            <Text color={COLORS.GRAY.GRAY_600}>
              You can find your ID in PensionPro. Navigate to{' '}
              <Text as="strong" fontWeight="500" color={COLORS.FINCH.BLACK}>
                Maintenance &gt; Firms/Locations
              </Text>{' '}
              and ensure the{' '}
              <Text as="strong" fontWeight="500" color={COLORS.FINCH.BLACK}>
                General
              </Text>{' '}
              view is open. The Tenant ID is found in this view.
            </Text>
          </Stack>
          <FormControl>
            <FormLabel>Tenant ID</FormLabel>
            <Input
              isDisabled={true}
              disabled={true}
              value={''}
              onChange={(e) => console.log(e.target.value)}
              fontSize={'14px'}
              padding={'12px'}
            />
          </FormControl>
        </HStack>
      </StackWithDivider>
    </ContentBox>
  );
}
